<template>
  <div>
    <el-alert
      show-icon
      title="友情提示"
      description="各职称评审办事机构组建职称评审委员会选取专家采用推荐和抽取相结合的方式，从专家库中自行推荐三分之一的专家，随机抽取三分之二的专家。
        高级资格（副高和正高）提出【抽取需求】，提交到自治区人力资源和社会保障厅进行抽取。
        中初级自行进行抽取。"
      type="warning"
    ></el-alert>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="loading"
      label-width="130px"
      class="mt10"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="抽取年度" prop="workYear">
            <el-radio-group v-model="form.workYear">
              <el-radio
                v-for="item in form.workYears"
                :key="item"
                :label="item"
                border
              >
                {{ item }}年
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="抽取名称" prop="title">
            <el-input
              v-model="form.title"
              maxlength="80"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="抽取级别">
            <el-tag v-show="form.isMiddle" class="mr2">初中级</el-tag>
            <el-tag v-show="form.isHigh">高级（副高、正高）</el-tag>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="抽取类型">
            <el-tag v-show="form.isSubject" class="mr2">
              学科组评审会(打分会)
            </el-tag>
            <el-tag v-show="form.isMixed">综合评审会(投票会)</el-tag>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="系列（专业）" prop="serId">
            <el-select
              v-model="form.serId"
              placeholder="请选择"
              v-if="!hasCreated"
            >
              <el-option
                v-for="item in form.serIds"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span v-else v-text="form.serName"></span>
            <div v-show="!hasCreated">
              <el-tag type="info">注意保存以后，此项不能再更改。</el-tag>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="需专家总数" prop="needCount">
            <el-input
              v-model.number="form.needCount"
              maxlength="2"
              show-word-limit
              placeholder="范围在3到99"
              v-if="!hasCreated"
            ></el-input>
            <span v-else v-text="form.needCount"></span>
            <el-tag type="info" v-show="!hasCreated">
              注意保存以后，此项不能再更改。
            </el-tag>
            <span v-show="form.isSubject" class="mt10">
              <el-tag type="danger" class="tip">
                自行推荐:
                <b>{{ form.selfCount }}</b>
                随机抽取:
                <b>{{ form.randCount }}</b>
                人
              </el-tag>
            </span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <div class="mt10">
          <el-button @click="handleClose">关闭</el-button>
          <el-button type="primary" @click="handleSave">
            保存并下一步
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getBase, updateBase } from '@/api/gains/base.js';

export default {
  data() {
    var validNeedCount = (rule, value, callback) => {
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (value < 3) {
          callback(new Error('必须大于等于3！'));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      form: {},
      // 表单校验
      rules: {
        workYear: [
          { required: true, message: '请选择抽取年度', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请输入抽取名称', trigger: 'blur' }],
        needCount: [
          { validator: validNeedCount, required: true, trigger: 'blur' }
        ],
        serId: [{ required: true, message: '系列（专业）', trigger: 'blur' }]
      }
    };
  },
  computed: {
    hasCreated() {
      return !!this.$route.params.gainEid;
    }
  },
  watch: {
    'form.needCount': {
      handler(newValue, oldValue) {
        if (this.hasCreated) {
          return;
        }
        if (newValue) {
          this.form.randCount = Math.round((newValue * 2) / 3.0);
          this.form.selfCount = newValue - this.form.randCount;
        }
      }
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          updateBase(
            this.$route.params.ver,
            this.$route.params.gainEid,
            this.form
          ).then(res => {
            this.loading = false;
            this.$router.push(`/gains/${this.$route.params.ver}/${res}/own`);
          });
        } else {
          return false;
        }
      });
    },
    handleClose() {
      window.close();
    },
    getData() {
      this.loading = true;
      getBase(this.$route.params.ver, this.$route.params.gainEid).then(res => {
        this.form = res;
        this.loading = false;
      });
    }
  },
  created() {
    this.$emit('loaded', 1);
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.tip {
  font-size: 14px;
}
</style>
